<template>
    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 border-2 shadow-md rounded">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" class="px-6 py-3" v-if="$slots.actions"></th>
                <th scope="col" class="px-6 py-3" v-for="header in headers" :key="header">{{ header }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in items" :key="item._id">
                <td class="px-6 py-4" v-if="$slots.actions">
                    <slot name="actions" :_id="item._id" :index="index"></slot>
                </td>
                <td class="px-6 py-4" v-for="field in fields" :key="field">
                    <span v-if="field !== 'status'">
                        <span v-if="links[field]">
                            <router-link :to="getLink(item, links[field])" class="underline text-sky-600">{{ item[field] }}</router-link>
                        </span>
                        <span v-else>{{ item[field] }}</span>
                    </span>
                    <span v-else>
                        <span v-if="item.status === 0"
                            class="bg-red-100 text-red-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-red-900 dark:text-red-300">{{ statusMessages[0] }}</span>
                        <span v-else
                            class="bg-green-100 text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">{{ statusMessages[1] }}</span>
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    props: {
        headers: {
            default: [],
        },
        fields: {
            default: [],
        },
        items: {
            default: []
        },
        statusMessages: {
            default: ['Not available', 'Available']
        },
        links: {
            default: {},
        }
    },

    methods: {
        getLink(item, link) {
            let linkVal = link.value;
            for (const param of link.params) {
                linkVal = linkVal.replace(`:${param}`, item[param]);
            }
            return linkVal;
        }
    }
}
</script>